import SCCFPicker from './SCCFPicker';

export default SCCFPicker;
